import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    auth: {
      authorized: false,
      user: '',
      role: null,
      baseUrl: 'll-pro.liveabc.com'
    },
    magOnly: false, // magazine 和 enterprise
    userInfo: null,
    breadcrumb: [],
    videoData: {},
    titleName: {},
    groupId: null,
    local: window.localStorage.getItem('locale'),

    remainPoints: 0,
    playbackRate: 1,
    isOpenSubtitle: true,
    selectedAccent: 'en-EN', // 'en-EN ', 'it-IT', 'en-GB', 'en-AU'
    followData: null
  },
  mutations: {
    isLoading (state, value) {
      state.isLoading = value
    },
    login (state, value) {
      state.auth.authorized = true
      state.magOnly = value.magOnly
      state.auth.user = value
    },
    logout (state, value) {
      state.auth.authorized = false
      state.auth.user = ''
      state.magOnly = false
      state.auth.role = null
    },
    setVideo (state, value) {
      const filteredSections = value.sections.filter(section => {
        return section.type === 'video' || section.type === 'live_course' || section.type === 'practice'
      })
      const customSort = (a, b) => {
        const order = { video: 1, live_course: 2, practice: 3 }
        return order[a.type] - order[b.type]
      }
      const sortedSections = filteredSections.sort(customSort)

      state.videoData = sortedSections
      state.titleName = {
        name: value.name,
        name_en: value.name_en
      }
    },
    setBreadcrumb (state, value) {
      state.breadcrumb[0] = value
    },
    setLocal (state) {
      state.local = window.localStorage.getItem('locale')
    },
    setRole (state, value) {
      state.auth.role = value.role
    },
    setMe (state, value) {
      state.userInfo = value
      console.log(value)
    },
    SETPOINTS (state, value) {
      state.remainPoints = value.data
    },
    SETPLAYBACKRATE (state, value) {
      state.playbackRate = value
    },
    TOGGLESUBTITLE (state, value) {
      state.isOpenSubtitle = value
    },
    SETACCENT (state, value) {
      state.selectedAccent = value
    },
    setFollowData (state, payload) {
      state.followData = payload
    },
    isLoading (state, payload) {
      state.isLoading = payload
    }
  },
  actions: {
    login: async ({ commit }, user) => {
      const fileData = new window.FormData()
      fileData.append('email', user.email)
      fileData.append('password', user.password)
      fileData.append('device_name', 'web')
      const { data } = await api.post('/login', fileData)
      commit('login', data)
      return data
    },
    getUser: async ({ commit }) => {
      const { data } = await api.get('/me')
      commit('setRole', data)
      commit('setMe', data)
    },
    logout: async ({ commit }) => {
      const { data } = await api.post('/logout')
      commit('logout', data)
    },
    getVideo: async ({ commit, dispatch }, id) => {
      const { data } = await api.get(`/contents/courses/${id}`)
      commit('setVideo', data.data)
    },
    getRemainPoints: ({ commit }) => {
      const options = { headers: { showLoading: false } }
      api.get('ai/generate/all/remain_count', options)
        .then(response => {
          if (response) {
            commit('SETPOINTS', { data: response.data.default })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    setPlayBackRate: ({ commit }, data) => {
      commit('SETPLAYBACKRATE', data)
    },
    toggleSubtitle: ({ commit }, data) => {
      commit('TOGGLESUBTITLE', data)
    },
    setAccent: ({ commit }, data) => {
      commit('SETACCENT', data)
    },
    isLoading: ({ commit }, data) => {
      commit('isLoading', data)
    },
    saveFollowData ({ commit }, payload) {
      return new Promise((resolve) => {
        localStorage.setItem('followData', JSON.stringify(payload))
        commit('setFollowData', payload)
        resolve()
      })
    },
    clearFollowData ({ commit }) {
      commit('setFollowData', null)
      localStorage.removeItem('followData')
    }
  },
  modules: {
  },
  plugins: [
    createPersistedState(
      {
        key: 'livelearning',
        paths: [
          'auth',
          'userInfo',
          'magOnly'
          // 'superAdmin'
        ]
      }
    )
  ],
  getters: {
    isLoading: state => state.isLoading,
    authorized: state => state.auth.authorized,
    role: state => state.auth.role,
    videoData: state => state.videoData,
    titleName: state => state.titleName,
    local: state => state.local,
    magOnly: state => state.magOnly,
    authInfo: state => state.auth,
    userInfo: state => state.userInfo,
    remainPoints: state => state.remainPoints,
    playbackRate: state => state.playbackRate,
    isOpenSubtitle: state => state.isOpenSubtitle,
    selectedAccent: state => state.selectedAccent,
    getFollowData: state => {
      if (!state.followData) {
        const saved = localStorage.getItem('followData')
        state.followData = saved ? JSON.parse(saved) : null
      }
      return state.followData
    }
  }
})
